export default __webpack_public_path__ + "static/media/dg-gallery-02.ce1bb9b8.jpg";